export default __webpack_public_path__ + "static/media/arqueira_overlap.203021a3.mp3";